import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import styles from './error.styles';
import { updateErrorMessageAction } from '../../../reducers/actions';

class Error extends Component {
  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }
  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = event => {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
      this.removeMessage();
    }
  };

  removeMessage = () => {
    this.props.updateErrorMsg('');
  };

  render() {
    const msg = this.props.msg || I18n.t('error.500');
    return (
      <div className={css(styles.text)} ref={node => (this.wrapperRef = node)}>
        <p className={css(styles.p)}>{msg}</p>
        <span onClick={this.removeMessage} className={css(styles.cross)}>
          &#10006;
        </span>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateErrorMsg() {
      dispatch(updateErrorMessageAction(...arguments));
    }
  };
};

export default connect(
  null,
  mapDispatchToProps
)(Error);



// WEBPACK FOOTER //
// ./src/components/common/errorBanner/error.js